
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from "sonner"
import AuthProvider from './contexts/AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from "@/contexts/ThemeContext";

import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import KolTracker from './pages/KolTracker';
import GlobalReach from './pages/GlobalReach';
import KolCompensation from './pages/KolCompensation';
import DeliverablePage from './pages/DeliverablePage';
import Settings from './pages/Settings';
import IntegrationSettings from './pages/IntegrationSettings';
import NotFound from './pages/NotFound';
import PaymentSuccess from './pages/PaymentSuccess';
import ProtectedLayout from './components/ProtectedLayout';
import Layout from './components/Layout';
import OnboardingFormPage from './pages/OnboardingFormPage';
import OnboardingSuccess from './pages/OnboardingSuccess';
import OnboardingPage from './pages/OnboardingPage';

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/onboarding" element={<OnboardingPage />} />
              <Route path="/onboarding/:formId" element={<OnboardingPage />} />
              <Route path="/onboarding-success/:formId" element={<OnboardingSuccess />} />
              <Route path="/payment-success/:formId" element={<PaymentSuccess />} />
              <Route element={<ProtectedLayout />}>
                <Route element={<Layout />}>
                  {/* Redirect root path to KOL Tracker page */}
                  <Route path="/" element={<Navigate to="/kol-tracker" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/kol-tracker" element={<KolTracker />} />
                  <Route path="/global-reach" element={<GlobalReach />} />
                  <Route path="/kol-compensation" element={<KolCompensation />} />
                  <Route path="/deliverable/:id" element={<DeliverablePage />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/integration-settings" element={<IntegrationSettings />} />
                </Route>
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster />
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
